import { render, staticRenderFns } from "./CompounedeStatus.vue?vue&type=template&id=c22dc064"
import script from "./CompounedeStatus.vue?vue&type=script&lang=js"
export * from "./CompounedeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports